var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.132812 8.94922C0.142578 8.46094 0.308594 8.06055 0.708984 7.67969L8.0918 0.443359C8.39453 0.150391 8.74609 0.00390625 9.17578 0.00390625C10.0352 0.00390625 10.748 0.707031 10.748 1.55664C10.748 1.98633 10.5625 2.38672 10.2402 2.69922L3.80469 8.93945L10.2402 15.1895C10.5625 15.5117 10.748 15.9023 10.748 16.3418C10.748 17.2012 10.0352 17.8945 9.17578 17.8945C8.74609 17.8945 8.39453 17.748 8.0918 17.4551L0.708984 10.2188C0.308594 9.82812 0.132812 9.42773 0.132812 8.94922Z",
    fill: "#9C85F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.bb6880ae139c6389a54eb1d10993e4b1.svg";
export { ForwardRef as ReactComponent };